import _objectSpread from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { reactive, toRefs, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { _receive } from '@/api/index';
import HeaderNav from '@/components/header-nav';
import { getTradeStatusName } from '@/util';
export default {
  name: 'MaterialSubmit',
  components: {
    'header-nav': HeaderNav
  },
  setup: function setup() {
    var router = useRouter();
    var route = useRoute();
    var state = reactive({
      isAdvance: route.query.isAdvance,
      isUpdate: route.query.isUpdate,
      transTypeText: '',
      vaId: +route.query.vaId || '',
      vaList: [],
      materialInfo: {}
    });
    var vaChange = function vaChange(vaId) {
      var vaInfo = state.vaList.find(function (va) {
        return va.id === vaId;
      });
      var transTypeText = vaInfo.transTypeText,
        transType = vaInfo.transType,
        channelBankCode = vaInfo.channelBankCode;
      state.transTypeText = transTypeText;
      state.vaId = vaId;
      var query = {
        vaId: vaId,
        transType: transType,
        channelBankCode: channelBankCode
      };
      if (state.isAdvance) query.isAdvance = state.isAdvance;
      if (['00', '10'].includes(vaInfo.transType)) {
        console.log('query:', query);
        router.replace({
          path: '/receive/material_submit/e_commerce',
          query: query
        });
      }
      if (['20', '30'].includes(vaInfo.transType)) {
        delete query.transType;
        router.replace({
          path: '/receive/material_submit/t_trade',
          query: query
        });
      }
    };
    var loadMaterialInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var materialInfo;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              materialInfo = sessionStorage.getItem('materialInfo');
              if (materialInfo) state.materialInfo = JSON.parse(materialInfo);else router.replace('/home/index');
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadMaterialInfo() {
        return _ref.apply(this, arguments);
      };
    }();
    var loadAllVAs = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, vaList, res, vaInfo;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              data = [];
              vaList = sessionStorage.getItem('vaList');
              if (!vaList) {
                _context2.n = 1;
                break;
              }
              data = JSON.parse(vaList);
              _context2.n = 3;
              break;
            case 1:
              _context2.n = 2;
              return _receive.getAllVAs();
            case 2:
              res = _context2.v;
              if (res.data.succ) data = res.data.data;
            case 3:
              state.vaList = data.map(function (item) {
                return Object.assign({}, item, {
                  transTypeText: getTradeStatusName(item.transType, 'receiveTransType')
                });
              });
              if (state.vaId) {
                vaInfo = state.vaList.find(function (va) {
                  return va.id === state.vaId;
                });
                state.transTypeText = vaInfo.transTypeText;
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function loadAllVAs() {
        return _ref2.apply(this, arguments);
      };
    }();
    var initPage = function initPage() {
      if (state.isAdvance || state.isUpdate) loadAllVAs();else loadMaterialInfo();
    };
    watch(function () {
      return router.currentRoute.value;
    }, function () {
      return initPage();
    }, {
      immediate: true
    });
    return _objectSpread({
      initPage: initPage,
      vaChange: vaChange
    }, toRefs(state));
  }
};